import { HttpClient } from '@angular/common/http';
import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-artificial-intelligence-rules',
  templateUrl: './artificialintelligencerules.component.html',
  styleUrls: ['./artificialintelligencerules.component.scss']
})
export class ArtificialIntelligenceRulesComponent implements AfterViewInit {
  public rulesText: string = '';
  public aiResponse: string = '';
  public aiResponseNextLadder: boolean = false;
  public isLoading: boolean = false;

  @ViewChild('rulesInput') rulesInput!: ElementRef<HTMLTextAreaElement>;

  constructor(private http: HttpClient) { }

  ngAfterViewInit() {
    setTimeout(() => {
      this.rulesInput?.nativeElement.focus();
    });
  }

  submitRules() {
    if (!this.rulesText.trim()) {
      return;
    }
    
    this.isLoading = true;
    this.aiResponse = '';
    
    this.http.post('/api/ai/rules', { question: this.rulesText }).subscribe(
      (result: any) => {
        this.aiResponse = this.processResponse(result.response);
        this.isLoading = false;
      },
      (error) => {
        console.error('Error calling AI API:', error);
        this.aiResponse = 'Error: Unable to get response from AI service.';
        this.isLoading = false;
      }
    );
  }

  clearForm() {
    this.rulesText = '';
    this.aiResponse = '';
    setTimeout(() => {
      this.rulesInput?.nativeElement.focus();
    });
  }

  private processResponse(response: any): string {
    if (!response) return '';
    if (response && response?.nextladder && response?.nextladder == true) {
      this.aiResponseNextLadder = true;
      return '';
    }
    
    // Convert escaped quotes to proper quotation marks
    let processed = response.replace(/\\"/g, '"');
    
    // Convert \n to actual line breaks
    processed = processed.replace(/\\n/g, '\n');
    
    return processed;
  }
} 
